import React from 'react';

import { Link, HoverableLink, Wrapper as ButtonWrapper, withBlockTypeConfigProps, withBlockTypeConfigPropsV2 } from '../common/Button.jsx';

// region BUTTON V1 (-- DEPRECATED Use `ButtonV2` --)

function _ButtonV1Component(props) {
    let Component = Link;
    if (props.hoverProps != undefined) {
        Component = HoverableLink;
    }
    let href = '#';
    let target;
    if (props.blockConfig && props.blockConfig.block) {
        if (props.blockConfig.block.url && props.blockConfig.block.url.length > 0) {
            href = props.blockConfig.block.url;
        }
        if (props.blockConfig.block.newWindow == true) {
            target = '_blank';
        }
    }
    if (props.url && props.url.length > 0) {
        href = props.url;
    }
    return (
        <div style={props.style}>
            <Component
                className="btn btn--custom"
                hoverProps={props.hoverProps}
                href={href}
                style={props.buttonStyle}
                target={target}
                type={props.type || "button"}
                onClick={props.onButtonClick}>
                {props.display}
            </Component>
        </div>
    );
}
const ButtonV1Component = withBlockTypeConfigProps(_ButtonV1Component, ['newWindow', 'url']);
const ButtonV1 = { Component: ButtonV1Component }

// region BUTTON V2

function _ButtonV2Component(props) {
    if (!props.builder && !props.design) {
        return null;
    }
    let Component = Link;
    if (props.hoverProps != undefined) {
        Component = HoverableLink;
    }
    let href = '#';
    let target;
    if (props.blockConfig && props.blockConfig.block) {
        if (props.blockConfig.block.url && props.blockConfig.block.url.length > 0) {
            href = props.blockConfig.block.url;
        }
        if (props.blockConfig.block.newWindow == true) {
            target = '_blank';
        }
    }
    if (props.url && props.url.length > 0) {
        href = props.url;
    }
    let className = 'btn btn--custom2 richText';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return (
        <ButtonWrapper {...props}>
            <Component
                className={className}
                design={props.design}
                hoverProps={props.hoverProps}
                href={href}
                style={props.style}
                target={target}
                type={props.type || "button"}
                onClick={props.onButtonClick} />
        </ButtonWrapper>
    );
}
const ButtonV2Component = withBlockTypeConfigPropsV2(_ButtonV2Component, ['newWindow', 'url']);
const ButtonV2 = { Component: ButtonV2Component }

// region BUTTON V3
const ButtonV3Component = withBlockTypeConfigPropsV2(_ButtonV2Component, ['newWindow', 'url'], true);
const ButtonV3 = { Component: ButtonV3Component }

export {
    ButtonV3,

    // DEPRECATED
    ButtonV1,
    ButtonV2
};